import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import { DeleteAccess } from '../models/deleteAccess.model';
import { GrantAccess } from '../models/grantAccess.model';
import { UpdateAccessOnAsset } from '../models/updateAccessOnAsset.model';


export interface GetAccessOnAsset {
  workspaceId: string;
  assetId: string;
  assetType: string;
  pageNumber: number;
  pageSize: number;
  needCount?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class PermissionsApi {
  api = environment.api;
  constructor(private http: HttpClient) { }

  getWorkspaceRoles(workspaceId: string): Observable<any>{
    return this.http.get<any>(`${this.api}/Role/GetWorkspaceRoles/${workspaceId}`);
  }
  getDefaultPermissions(): Observable<any> {
    return this.http.get<any>(`${this.api}/Permission/GetPermissions`);
  }
  getUsersAndUserGroups(body: GetAccessOnAsset): Observable<any> {
    return this.http.post<any>(this.api +'/Access/GetAccessOnAsset', body);
  }
  getUsersNewAccess(body: GrantAccess) {
    return this.http.post<any>(this.api +'/Access/GetUserSoloGroups', body);
}
  updateDashboard(body: UpdateAccessOnAsset): Observable<any>  {
    return this.http.post<any>(this.api +'/Access/UpdateDashboardAccess',body);
  }

  updateDataSource(body: UpdateAccessOnAsset): Observable<any>  {
    return this.http.post<any>(this.api +'/Access/UpdateDataSourceAccess',body);
  }

  updateDashboardGroup(body: UpdateAccessOnAsset): Observable<any>  {
    return this.http.post<any>(this.api +'/Access/UpdateDashboardGroupAccess',body);
  }

  updateChart(body: UpdateAccessOnAsset): Observable<any>  {
    return this.http.post<any>(this.api +'/Access/UpdateChartAccess',body);
  }

  deleteUserAccess(body: DeleteAccess) {
    return this.http.post<any>(this.api +'/Access/DeleteAccess', body);
  }
}
